import React from "react";

import Styles from "./TableNextSessions.module.css";

import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Avatar from "@material-ui/core/Avatar";

const useStyles = makeStyles((theme) => ({
	tableActions: {
		width: "100%",
	},
}));

const TableNextSessions = (props) => {
	const classes = useStyles();

	const sessions = [...props.TableNextSessionsData.pageData.trainingSessions];

	console.log("sessions", sessions)

	return (
		<div className={Styles["TableNextSessions"]}>
			<Table className={classes.table} aria-label="Actions table">
				<TableHead>
					<TableRow className={Styles["MuiTableRow-head"]}>
						<TableCell
							className={Styles["MuiTableCell-head"]}
							align="left"
						>
							<div className={Styles["title"]}>Data</div>
						</TableCell>
						<TableCell
							className={Styles["MuiTableCell-head"]}
							align="left"
						>
							<div className={Styles["title"]}>Hora Início</div>
						</TableCell>
						<TableCell
							className={Styles["MuiTableCell-head"]}
							align="left"
						>
							<div className={Styles["title"]}>Hora Fim</div>
						</TableCell>
						<TableCell
							className={Styles["MuiTableCell-head"]}
							align="left"
						>
							<div className={Styles["title"]}>Formador</div>
						</TableCell>
						<TableCell
							className={Styles["MuiTableCell-head"]}
							align="left"
						>
							<div className={Styles["title"]}>Local</div>
						</TableCell>
						<TableCell
							className={Styles["MuiTableCell-head"]}
							align="left"
						>
							<div className={Styles["title"]}>Sala</div>
						</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{sessions.map((row) => (
						<TableRow
							key={row.id}
							className={Styles["MuiTableBody-root"]}
						>
							<TableCell
								className={Styles["MuiTableCell-root"]}
								align="left"
								component="th"
								scope="row"
							>
								<div className={Styles["subtitle"]}>
									{row.dateString}
								</div>
							</TableCell>
							<TableCell
								className={Styles["MuiTableCell-root"]}
								align="left"
							>
								<div className={Styles["subtitle"]}>
									{row.startTime}
								</div>
							</TableCell>
							<TableCell
								className={Styles["MuiTableCell-root"]}
								align="left"
							>
								<div className={Styles["subtitle"]}>
									{row.endTime}
								</div>
							</TableCell>
							<TableCell
								className={Styles["MuiTableCell-root"]}
								align="left"
							>
								<div
									className={`${Styles["subtitle"]} ${Styles["former-avatar"]}`}
								>									
									{row.instructor && <Avatar className={Styles["avatar-letter"]}>
										{`${row.instructor.name
											.split(" ")[0]
											.charAt(0)}${row.instructor.name
											.split(" ")[1]
											.charAt(0)}`}
									</Avatar>}
									{row.instructor && row.instructor.name}
								</div>
							</TableCell>
							<TableCell
								className={Styles["MuiTableCell-root"]}
								align="left"
							>
								<div className={Styles["subtitle"]}>
									{row.room && row.room.place.name}
								</div>
							</TableCell>
							<TableCell
								className={Styles["MuiTableCell-root"]}
								align="left"
							>
								<div className={Styles["subtitle"]}>
									{row.room && row.room.name}
								</div>
							</TableCell>
						</TableRow>
					))}
				</TableBody>
			</Table>
		</div>
	);
};

export default TableNextSessions;
